import React from 'react'
import { TOOL_TEMPLATE } from '../constant/common';
import { useTemplateSetting } from '../hooks/useCompanySettings'
import Icon from './ui/Icon'

/**
 * @typedef { import('../..').ExtractPropsComponent<typeof Icon> } IconProps
 * @param {{quadrata: IconProps['name'], victor: IconProps['name'], className: string}} param0 
 * @returns 
 */
const IconByTemplate = ({quadrata, victor, ...props}) => {
    const template = useTemplateSetting();
    return <Icon name={template === TOOL_TEMPLATE.victor ? victor : quadrata} {...props} />
}


IconByTemplate.propTypes = {
    quadrata: Icon.propTypes['name'],
    victor: Icon.propTypes['name'],
}

export default IconByTemplate